module.exports = __webpack_public_path__ + "static/media/discord.efd64764.png";